<section *ngIf="viewAVCInvoices; else noPermissions" class="invoice-migration">
  <p class="invoice-migration__message">{{ migrationMessage }}</p>
  <a
    class="btn btn-primary invoice-migration__link"
    [href]="eBillingPortalUrl"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span>{{ eBillingPortalLabel }}</span>
  </a>
</section>

<ng-template #noPermissions>
  <div class="d-flex justify-content-center">
    <figure class="figure" data-test="kaliuk">
      <svg class="kaliuk kaliuk-big">
        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
      </svg>
      <figcaption class="figure-caption">
        <h4 i18n="@@amadeus-direct.avc-dashboard.invoices.no-permissions">
          No data retrieved. Please request permission to access data.
        </h4>
      </figcaption>
    </figure>
  </div>
</ng-template>
